import { findQueries, QueryWithParameters } from '@lmt/expressions';
import { VisitCardLineStyle, JsQuery } from '@lmt/shared-types';
import { emptyArray } from '@lmt/unicorn-shared/app/helpers/common';

const secondsInHour = 3600;

export function getHoursFromSeconds(seconds: number | null | undefined) {
  if (seconds === null || seconds === undefined) return undefined;
  const value = Number(seconds);
  return !isNaN(value) ? Math.floor(value / secondsInHour) : undefined;
}

export async function getQueriesFromVisitCardSettings(
  visitCardLineStyles: VisitCardLineStyle[] | undefined,
): Promise<JsQuery[]> {
  const queries = await Promise.all(
    visitCardLineStyles?.map((x) => findQueries(x.expression)) ??
      emptyArray<QueryWithParameters>(),
  );
  const unitedArrays = emptyArray<QueryWithParameters>().concat(...queries);
  const result = unitedArrays.map(
    (x) =>
      ({
        queryType: x.query.queryType,
        dataBlockTypeName: x.query.dataBlockTypeName,
        filter: x.filter!,
        limit: x.limit!,

        expressionFunctionName: x.expressionFunctionName!,
        expressionFunctionArgument: x.expressionFunctionArgument!,

        fields: x.fields.join(','),
      }) as JsQuery,
  );
  return result;
}
